import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-culture-impact-tag',
  templateUrl: './culture-impact-tag.component.html',
  styleUrl: './culture-impact-tag.component.scss',
})
export class CultureImpactTagComponent extends BaseComponent {
  @Input() impact = 0; // 0-100
  impactText: string = '';

  constructor(private translateService: TranslateService) {
    super();
  }

  ngOnInit(): void {
    this.calculateImpactText();
  }

  ngOnChanges(): void {
    this.calculateImpactText();
  }

  calculateImpactText(): void {
    if (this.impact < ImpactLevelUpperThresholds.VeryLow) {
      this.impactText = this.translateService.instant('stateView.impactTagTexts.veryLowImpact');
    }
    else if (this.impact < ImpactLevelUpperThresholds.Low) {
      this.impactText = this.translateService.instant('stateView.impactTagTexts.lowImpact');
    }
    else if (this.impact < ImpactLevelUpperThresholds.Medium){
      this.impactText = this.translateService.instant('stateView.impactTagTexts.mediumImpact');
    }
    else{
      this.impactText = this.translateService.instant('stateView.impactTagTexts.highImpact');
    }
    // else{
    //   this.impactText = this.translateService.instant('stateView.impactTagTexts.veryHighImpact');
    // }
  }
}

export enum ImpactLevelUpperThresholds {
  VeryLow = 25,
  Low = 45,
  Medium = 60
}

// VeryLow = 50,
// Low = 70,
// Medium = 80,
// High = 90
